import { useCallback, useMemo, useState } from 'react';

export const useOpenValue = <T extends any = string>(init: T | null | undefined = undefined) => {
  const [openValue, setOpenValue] = useState<T | null | undefined>(init);

  const onOpen = useCallback((value: T) => {
    setOpenValue(value);
  }, []);
  const onClose = useCallback(() => {
    setOpenValue(null);
  }, []);

  return useMemo(() => {
    return {
      openValue,
      setOpenValue,
      onOpen,
      onClose,
    };
  }, [openValue, setOpenValue, onOpen, onClose]);
};
